import React from 'react';

import clsx from 'clsx';

import EsmsDialog from '../../components/EsmsDialog';

import * as classes from './SensorWarningModal.module.css';

const SensorWarningModal = ({
    warningModalOpen,
    setWarningModalOpen,
    handleSubmit,
    handleReset,
    ...props
}) => {

    const handleCancel = () => {
        handleReset();
        setWarningModalOpen(false);
    };

    return (
        <EsmsDialog
            open={warningModalOpen}
            onClose={() => handleCancel()}
            title={'Agent Warning'}
            onConfirm={() => handleSubmit()}
            confirmText="Yes"
        >
            <div className={classes.Body}>
                <span className={clsx('material-symbols-outlined', classes.Warning)}>
                    warning
                </span>
                <span className={classes.Text}>
                    Warning, you are over the recommended 4,000 point limit for an agent. Continuing may cause performance and stability issues. Do you want to continue?
                </span>
            </div>
        </EsmsDialog>
    );
};

export default SensorWarningModal;
